"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function stackedLayout(data) {
    return new StackedLayout(data);
}
exports.stackedLayout = stackedLayout;
var StackedLayout = /** @class */ (function () {
    function StackedLayout(data) {
        this._data = data;
    }
    StackedLayout.prototype.value = function (fn) {
        this._value = fn;
        return this;
    };
    StackedLayout.prototype.extent = function (fn) {
        this._extentOf = fn;
        return this;
    };
    StackedLayout.prototype.run = function () {
        var _this = this;
        // sort
        this._data.sort(function (a, b) { return _this._value(a) - _this._value(b); });
        // stack
        var currentLayer = 0;
        var layerMaxValue = [Number.MIN_VALUE];
        // process
        return this._data.map(function (d) {
            var layerExtent = _this._extentOf.length > 1;
            var extent;
            if (!layerExtent) {
                extent = _this._extentOf(d);
            }
            var placedLayer = -1;
            for (var layer = 0; layer <= currentLayer; layer += 1) {
                if (layerExtent) {
                    extent = _this._extentOf(d, layer);
                }
                if (layerMaxValue[layer] < extent[0]) {
                    // place
                    layerMaxValue[layer] = extent[1];
                    placedLayer = layer;
                    break;
                }
            }
            if (placedLayer < 0) {
                currentLayer += 1;
                layerMaxValue[currentLayer] = extent[1];
                placedLayer = currentLayer;
            }
            return __assign(__assign({}, d), { __layer__: placedLayer });
        });
    };
    return StackedLayout;
}());
exports.StackedLayout = StackedLayout;
//# sourceMappingURL=stacked-layout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/algo/stacked-layout.js
// module id = 879
// module chunks = 0 1